"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preprocessErrorTextForReduxForm = exports.formatErrorText = void 0;
var formatErrorText = exports.formatErrorText = function formatErrorText(errorResponse) {
  var result = "".concat(errorResponse.errorcode, ": ").concat(errorResponse.errormsg);
  if (errorResponse.detail) {
    result = "".concat(result, ": ").concat(errorResponse.detail);
  }
  return result;
};

/**
 * The point of this function is to:
 *  1. Relate a generalized server errormsg to a specific form-field.
 *  2. Return formatted errormsg in a form that redux-form expects.
 *  3. Use `_error` for non-field-specific messages.
 *
 * @param {String} _error : This is the server response, `response.errormsg`.
 * @param {Object} formValues : Form values.
 */
var preprocessErrorTextForReduxForm = exports.preprocessErrorTextForReduxForm = function preprocessErrorTextForReduxForm(_error, formValues) {
  return Object.keys(formValues).reduce(function (acc, key) {
    if (_error.toLowerCase().includes(key.toLowerCase())) {
      acc._error = '';
      acc[key] = _error;
    }
    return acc;
  }, {
    _error: _error
  });
};